import { useParams } from "react-router";
import { ElementsPanel } from "../invention/ElementsPanel";
import { StagePage } from "../layout/StagePage";
import { stageHeadingLabel } from "@/v2/stage-vocabulary";

/**
 * Thesis, page 1. What the invention is made of.
 *
 * Elements the attorney typed sit alongside whatever the derivation from the
 * intake documents found. A matter opens with neither, so the empty state
 * says so plainly rather than reading as a failure.
 */
export function InventionStagePane() {
  const { taskId } = useParams<{ taskId: string }>();

  return (
    <StagePage
      guide="invention"
      eyebrow={`${stageHeadingLabel("thesis")} · Invention`}
      title="Define the invention"
      // The design's words. Its "access it's novelty" is corrected to "assess
      // its novelty". The elements panel says when the reading is still under
      // way, so the past tense here holds.
      measure="thesis"
      lede={
        <>
          Before we can assess its novelty,{" "}
          <strong className="font-bold text-foreground">
            we need to pin down exactly what the invention is
          </strong>
          . I&rsquo;ve used the information you provided during Intake to
          identify the <em>key elements of the invention</em>. These elements
          will form the basis of claims in later sections. Some of the elements
          I&rsquo;ve identified may require your attention to confirm their
          accuracy. Once you&rsquo;re happy with the wording, we&rsquo;ll be
          able to determine how novel this invention is.
        </>
      }
    >
      <ElementsPanel taskId={taskId ?? null} />
    </StagePage>
  );
}
